import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useSmoothScroll, scrollToId } from "@/hooks/useSmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Quote } from "@/components/Quote";
import { BrandBanner } from "@/components/BrandBanner";
import { BrandDeskBanner } from "@/components/BrandDeskBanner";
import { Services } from "@/components/Services";
import { Signature } from "@/components/Signature";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { HowItWorks } from "@/components/HowItWorks";
import { WhoWeServe } from "@/components/WhoWeServe";
import { Commitment } from "@/components/Commitment";
import { Testimonials } from "@/components/Testimonials";
import { CTA } from "@/components/CTA";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Landing() {
  useSmoothScroll();
  const goContact = () => scrollToId("contact");

  return (
    <div className="App grain">
      <Navbar onConsult={goContact} />
      <main>
        <Hero onConsult={goContact} />
        <About />
        <Quote />
        <BrandBanner />
        <Services onConsult={goContact} />
        <Signature onConsult={goContact} />
        <BrandDeskBanner />
        <WhyChooseUs />
        <HowItWorks onConsult={goContact} />
        <WhoWeServe />
        <Testimonials />
        <Commitment />
        <CTA />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#262019",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#fff",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
